/* RUBY MINT — SP/SU 2027 splash: scroll reveals + sticky logo bar */
(function () {
  var revealAll = function () {
    document.querySelectorAll('.rm-reveal').forEach(function (el) { el.classList.add('is-in'); });
  };

  try {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var targets = document.querySelectorAll('.rm-reveal');

    /* --- reveal on scroll --- */
    if (reduce || !('IntersectionObserver' in window)) {
      revealAll();
    } else {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -12% 0px', threshold: 0.06 });
      targets.forEach(function (el) { io.observe(el); });

      /* safety net: never leave copy invisible if the observer misfires */
      setTimeout(function () {
        document.querySelectorAll('.rm-reveal:not(.is-in)').forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-in');
        });
      }, 2500);
    }

    /* --- sticky logo bar appears once the hero is scrolled past --- */
    var bar = document.querySelector('[data-rm-bar]');
    var hero = document.querySelector('[data-rm-hero]');
    if (bar && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        bar.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { rootMargin: '-72px 0px 0px 0px', threshold: 0 }).observe(hero);
    }

    /* --- email capture -> Klaviyo (falls back to the Shopify customer post) --- */
    var forms = [].slice.call(document.querySelectorAll('[data-rm-signup]'));
    if (forms.length) {
      /* config only has to be filled in on one of the signup sections */
      var cfg = { key: '', list: '' };
      forms.forEach(function (f) {
        cfg.key = cfg.key || (f.getAttribute('data-klaviyo-key') || '').trim();
        cfg.list = cfg.list || (f.getAttribute('data-klaviyo-list') || '').trim();
      });

      if (cfg.key && cfg.list) {
        forms.forEach(function (form) {
          form.addEventListener('submit', function (ev) {
            var email = form.querySelector('input[type="email"]');
            if (!email || !email.value || !email.checkValidity()) return;  // let the browser complain
            var trap = form.querySelector('[name="rm_company"]');
            if (trap && trap.value) { ev.preventDefault(); return; }

            ev.preventDefault();
            var status = form.querySelector('[data-rm-status]');
            var button = form.querySelector('button[type="submit"]');
            var say = function (msg) { if (status) { status.textContent = msg; status.hidden = !msg; } };

            if (button) { button.disabled = true; button.dataset.label = button.textContent; button.textContent = 'Sending'; }
            say('');

            fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.key), {
              method: 'POST',
              headers: { 'content-type': 'application/json', revision: '2024-10-15' },
              body: JSON.stringify({
                data: {
                  type: 'subscription',
                  attributes: {
                    custom_source: form.getAttribute('data-source') || 'Splash page',
                    /* the client endpoint takes a bare profile — a `subscriptions`
                       block here is rejected with 400. Consent comes from the
                       endpoint itself plus the list's opt-in setting. */
                    profile: {
                      data: {
                        type: 'profile',
                        attributes: { email: email.value.trim() }
                      }
                    }
                  },
                  relationships: { list: { data: { type: 'list', id: cfg.list } } }
                }
              })
            })
              .then(function (res) {
                if (!res.ok && res.status !== 202) throw new Error('HTTP ' + res.status);
                var row = form.querySelector('.rm-signup__row');
                if (row) row.hidden = true;
                var note = form.querySelector('.rm-signup__note:not([data-rm-status])');
                if (note) note.hidden = true;
                say(form.getAttribute('data-success') || 'You\u2019re on the list.');
              })
              .catch(function () {
                say('That didn\u2019t send. Try again, or email sales@rubymint.com.');
                if (button) { button.disabled = false; button.textContent = button.dataset.label; }
              });
          });
        });
      }
    }

    /* --- catalog gate: compare a SubtleCrypto hash of the input with the
           digest Liquid rendered; the password itself is never in the page --- */
    var gates = [].slice.call(document.querySelectorAll('[data-rm-gate]'));
    gates.forEach(function (form) {
      var box = form.parentNode;
      var unlocked = box ? box.querySelector('[data-rm-unlocked]') : null;
      var input = form.querySelector('input[type="password"]');
      var status = form.querySelector('[data-rm-status]');
      var hash = (form.getAttribute('data-hash') || '').trim().toLowerCase();
      var key = 'rm-gate:' + hash.slice(0, 16);
      var say = function (msg, isError) {
        if (!status) return;
        status.textContent = msg || '';
        status.hidden = !msg;
        status.classList.toggle('is-error', !!isError);
      };
      var open = function () {
        form.hidden = true;
        if (unlocked) unlocked.hidden = false;
        try { sessionStorage.setItem(key, '1'); } catch (e) { /* private mode */ }
      };

      if (!hash) { open(); return; }                       /* no password set: no gate */
      try { if (sessionStorage.getItem(key) === '1') { open(); return; } } catch (e) { /* ignore */ }

      form.addEventListener('submit', function (ev) {
        ev.preventDefault();
        var value = input ? (input.value || '').trim() : '';
        if (!value) { say(form.getAttribute('data-empty'), true); if (input) input.focus(); return; }
        if (!(window.crypto && window.crypto.subtle && window.TextEncoder)) {
          say(form.getAttribute('data-unsupported'), true); return;
        }
        window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(value)).then(function (buf) {
          var hex = Array.prototype.map.call(new Uint8Array(buf), function (b) {
            return ('0' + b.toString(16)).slice(-2);
          }).join('');
          if (hex === hash) {
            say('');
            open();
            var link = unlocked ? unlocked.querySelector('a') : null;
            if (link) link.focus();
          } else {
            say(form.getAttribute('data-error'), true);
            if (input) input.select();
          }
        }).catch(function () { say(form.getAttribute('data-unsupported'), true); });
      });
    });

    /* --- smooth anchor scrolling from the contents index --- */
    document.querySelectorAll('[data-rm-jump]').forEach(function (a) {
      a.addEventListener('click', function (ev) {
        var t = document.querySelector(a.getAttribute('href'));
        if (!t) return;
        ev.preventDefault();
        t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
  } catch (err) {
    /* if anything above breaks, the page must still be readable */
    revealAll();
  }
})();
